import PropTypes from "prop-types";
import React from "react";

import { useDeviceInfo } from "@swa-ui/browser";
import { CallToAction } from "@swa-ui/placements";
import { classNames } from "@swa-ui/string";

import styles from "./ALGTransitionBannerPlacement.module.scss";

// TODO - Remove this component and cleanup ManageMyVacationsFlyout once ALG transition is complete.
export const ALGTransitionBannerPlacement = (props) => {
  const {
    mobileView = false,
    placement: {
      callToAction,
      styles: placementStyles,
      text: { primary, secondary },
    },
  } = props;
  const { screenSize } = useDeviceInfo();

  return (
    <div className={getBannerClasses()} style={placementStyles}>
      <div className={styles.textBlock}>
        <div className={styles.primary}>{primary.value}</div>
        <div className={styles.secondary}>{secondary.value}</div>
      </div>
      <div>{renderCallToActions()}</div>
    </div>
  );

  function renderCallToActions() {
    return callToAction.map((placementProps) => {
      const ctaProps = {
        ...placementProps,
        ...(screenSize === "small" && { size: "minimal" }),
        className: classNames(styles.ctaButton, { [styles.noSpacing]: mobileView }),
      };

      return <CallToAction key={placementProps.text} {...ctaProps} />;
    });
  }

  function getBannerClasses() {
    return classNames({
      [styles.banner]: true,
      [styles.responsiveBanner]: !mobileView,
    });
  }
};

ALGTransitionBannerPlacement.propTypes = {
  /** Forces the banner to only use the mobile breakpoint CSS.  */
  mobileView: PropTypes.bool,

  /** Placement object for the ALG transition banner.  */
  placement: PropTypes.shape({
    callToAction: PropTypes.arrayOf(PropTypes.object),
    styles: PropTypes.object,
    text: PropTypes.shape({
      primary: PropTypes.shape({
        value: PropTypes.string,
      }),
      secondary: PropTypes.shape({
        value: PropTypes.string,
      }),
    }),
  }),
};
